// extracted by mini-css-extract-plugin
export default {"adminWrap":"administrator_adminWrap__AL6ky"};